import React, { Component } from "react";
import styled from "styled-components";
import { Link, withRouter } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faQuestion, faTimes } from "@fortawesome/free-solid-svg-icons";

const Container = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Button = styled.label`
  padding: 10px 20px;
  margin: 0px 5px;
  border-radius: 15px;
  font-size: 14px;
  background-color: rgba(24, 12, 12, 1);
  color: white;
  &:hover {
    background-color: white;
    color: rgba(24, 12, 12, 1);
    transition: 0.3s ease-in-out;
    /* box-shadow: 0px 0px 15px 0px rgba(24, 12, 12, 1); */
  }
`;

const TipBox = styled.div`
  position: absolute;
  width: 300px;
  height: 50px;
  font-size: 12px;
  background-color: rgba(24, 12, 12, 1);
  border-radius: 25px;
  display: flex;
  bottom: -60px;
  justify-content: center;
  text-align: center;
  align-items: center;
  color: white;
  &:after {
    content: "";
    position: absolute;
    top: -7px;
    width: 0;
    height: 0;
    left: 50%;
    margin-left: -10px;
    border-bottom: solid 10px rgba(24, 12, 12, 1);
    border-left: solid 10px transparent;
    border-right: solid 10px transparent;
  }
`;

const Input = styled.input`
  display: none;
  &:checked ~ ${TipBox} {
    opacity: 1;
    transform: translate(0, 5px);
    transition: 0.3s ease-in-out;
  }

  &:not(:checked) ~ ${TipBox} {
    opacity: 0;
    transform: translate(0, 0px);
    transition: 0.3s ease-in-out;
  }
`;

class Help extends Component {
  constructor(props) {
    super(props);
    this.state = {
      mode: false
    };
    this.IconHandler = this.IconHandler.bind(this);
  }

  IconHandler() {
    this.setState({ mode: this.state.mode ? false : true });
  }

  render() {
    const { mode } = this.state;
    const { value } = this.props;
    return (
      <Container>
        <Input
          defaultChecked={false}
          type="checkbox"
          name="radio"
          id="0"
          onChange={this.IconHandler}
        />
        <Button htmlFor="0">
          {mode ? (
            <FontAwesomeIcon icon={faTimes} />
          ) : (
            <FontAwesomeIcon icon={faQuestion} />
          )}
        </Button>
        <TipBox>{value}</TipBox>
      </Container>
    );
  }
}

export default Help;
